import React from 'react';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import Card from '../Card/Card';
import { getClearOrCancelTitle, setDisableButton } from '../../helper/disableComponent';
import { SAVE_BUTTON_LABEL } from '../../constants/translationLabels/formElements';

const FormWrapper = ({
                         title,
                         submitClassName,
                         onSubmit,
                         onReset,
                         isDirty,
                         isSubmitting,
                         entityId,
                         children,
                         noCard = false,
                         submitLabel,
                         showReset = true,
                         formClassName,
                     }) => {
    const { t } = useTranslation('formElements');
    const content = (
        <>
            {title && <h2 style={{ textAlign: 'center' }}>{title}</h2>}
            <form onSubmit={onSubmit} className={formClassName}>
                {children}
                {/* Backing out sits left of the action, the same way every dialog orders them. */}
                <div className={`form-buttons-container form-btns ${!showReset ? 'single-button' : ''}`}>
                    {showReset && (
                        <Button
                            type="button"
                            variant="outlined"
                            color="primary"
                            className="buttons-style"
                            disabled={setDisableButton(!isDirty, isSubmitting, entityId)}
                            onClick={onReset}
                        >
                            {getClearOrCancelTitle(entityId, t)}
                        </Button>
                    )}
                    <Button
                        variant="contained"
                        color="primary"
                        className={`buttons-style ${submitClassName || ''}`}
                        disabled={!isDirty || isSubmitting}
                        type="submit"
                    >
                        {submitLabel || t(SAVE_BUTTON_LABEL)}
                    </Button>
                </div>
            </form>
        </>
    );

    return noCard ? content : <Card additionClassName="form-card">{content}</Card>;
};

export default FormWrapper;